<template>
  <div>
    <div
      class="goodsManageSet"
      :class="{ fixedStyle: isShowStyle }"
      :style="{ top: scrollTop + 'px' }"
    >
      <div class="banner">
        <img src="../../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div>
        <div class="breadcrumb_item">SKU管理</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">商品管理</div>
      </div>

      <div class="main_content">
        <div class="tit">多币种价格设置</div>
        <div class="exrate">
          <p>最新汇率参考：</p>
          <p>
            <span v-for="(item, index) in exchangeRates" :key="index"
              >人民币兑{{ item.Currencystr }}：1比{{ item.rate }}；</span
            >
          </p>
        </div>
        <div class="price_custom_wrap">
          <div class="tit">商品人民币原价</div>
          <div class="price_custom_content">
            <div
              class="price_block"
              v-for="(item, index) in priceCustom"
              :key="index"
            >
              <div class="original">{{ item.text }}：{{ item.original }}</div>
              <div class="input_box">
                <van-field
                  v-model="item.inputValue"
                  placeholder="输入外贸渠道溢价值"
                  oninput="value=value.replace(/^([0-9-]\d*\.?\d{0,2})?.*$/,'$1')"
                  @input="updateCalculate($event, item.type)"
                />
              </div>
              <div class="calculate">外贸渠道锚定价：{{ item.calculate }}</div>
            </div>
          </div>
        </div>
        <div class="primary-button account_btn" @click="handleAccount">
          自动换算所有价格
        </div>
        <div class="block">
          <!-- <div class="block_item flex-colc">
            <h1>越南盾零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_price_base"
                placeholder="越南盾零售底价"
                @focus="inputFocus"
                @blur="inputBlur"
                @input="handleBlurPrice('yue_price_base')"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('yue_price_base', 'cbprice', '越南盾')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>越南盾团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_tuan_base"
                placeholder="越南盾团批底价"
                @focus="inputFocus"
                @blur="inputBlur"
                @input="handleBlurPrice('yue_tuan_base')"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('yue_tuan_base', 'pfprice', '越南盾')"
            >
              单项价格重新核算
            </div>
          </div> -->
          <div class="block_item flex-colc">
            <h1>越南盾零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_price"
                placeholder="越南盾零售价"
                @focus="inputFocus"
                @blur="inputBlur"
                @input="handleBlurPrice('yue_price', '越南盾')"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('yue_price', 'price', '越南盾')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>越南盾团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.yue_tuan"
                placeholder="越南盾团批价"
                @focus="inputFocus"
                @blur="inputBlur"
                @input="handleBlurPrice('yue_tuan', '越南盾')"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('yue_tuan', 'groupprice', '越南盾')"
            >
              单项价格重新核算
            </div>
          </div>
        </div>

        <div class="block">
          <!-- <div class="block_item flex-colc">
            <h1>泰铢零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_price_base"
                @input="handleBlurPrice('tai_price_base')"
                placeholder="铢零售底价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('tai_price_base', 'cbprice', '泰铢')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>泰铢团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_tuan_base"
                @input="handleBlurPrice('tai_tuan_base')"
                placeholder="泰铢团批底价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('tai_tuan_base', 'pfprice', '泰铢')"
            >
              单项价格重新核算
            </div>
          </div> -->
          <div class="block_item flex-colc">
            <h1>泰铢零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_price"
                @input="handleBlurPrice('tai_price', '泰铢')"
                placeholder="泰铢零售价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('tai_price', 'price', '泰铢')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>泰铢团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.tai_tuan"
                @input="handleBlurPrice('tai_tuan', '泰铢')"
                placeholder="泰铢团批价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('tai_tuan', 'groupprice', '泰铢')"
            >
              单项价格重新核算
            </div>
          </div>
        </div>

        <div class="block">
          <!-- <div class="block_item flex-colc">
            <h1>卢布零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_price_base"
                @input="handleBlurPrice('lu_price_base')"
                placeholder="卢布零售底价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('lu_price_base', 'cbprice', '卢布')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>卢布团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_tuan_base"
                @input="handleBlurPrice('lu_tuan_base')"
                placeholder="卢布团批底价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('lu_tuan_base', 'pfprice', '卢布')"
            >
              单项价格重新核算
            </div>
          </div> -->
          <div class="block_item flex-colc">
            <h1>卢布零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_price"
                @input="handleBlurPrice('lu_price', '卢布')"
                placeholder="卢布零售价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('lu_price', 'price', '卢布')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>卢布团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.lu_tuan"
                @input="handleBlurPrice('lu_tuan', '卢布')"
                placeholder="卢布团批价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('lu_tuan', 'groupprice', '卢布')"
            >
              单项价格重新核算
            </div>
          </div>
        </div>

        <div class="block">
          <!-- <div class="block_item flex-colc">
            <h1>加拿大元零售底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_price_base"
                @input="handleBlurPrice('jia_price_base')"
                placeholder="加拿大元零售底价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('jia_price_base', 'cbprice', '加拿大元')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>加拿大元团批底价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_tuan_base"
                @input="handleBlurPrice('jia_tuan_base')"
                placeholder="加拿大元团批底价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('jia_tuan_base', 'pfprice', '加拿大元')"
            >
              单项价格重新核算
            </div>
          </div> -->
          <div class="block_item flex-colc">
            <h1>加拿大元零售价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_price"
                @input="handleBlurPrice('jia_price', '加拿大元')"
                placeholder="加拿大元零售价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('jia_price', 'price', '加拿大元')"
            >
              单项价格重新核算
            </div>
          </div>
          <div class="block_item flex-colc">
            <h1>加拿大元团批价</h1>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.jia_tuan"
                @input="handleBlurPrice('jia_tuan', '加拿大元')"
                placeholder="加拿大元团批价"
              ></van-field>
            </div>
            <div
              class="rest_btn"
              @click="handleUnitPrice('jia_tuan', 'groupprice', '加拿大元')"
            >
              单项价格重新核算
            </div>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, getCommidityDetail } from "../../../api/api";
import { mapState } from "vuex";
import {
  accountShopMultiPrice,
  getShopMultiPrice,
  addShopMultiPrice,
  editShopMultiPrice,
  getExrateList,
} from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
export default {
  name: "cMultiPrice",
  data() {
    return {
      isShowStyle: false,
      scrollTop: 0,
      priceCustom: [
        // {
        //   type: "cbprice",
        //   text: "商品零售分销底价（/件）",
        //   original: "",
        //   inputValue: "",
        //   calculate: "",
        // },
        // {
        //   type: "pfprice",
        //   text: "商品批发（团批）分销底价（/件）",
        //   original: "",
        //   inputValue: "",
        //   calculate: "",
        // },
        {
          type: "price",
          text: "商品基础零售价（/件）",
          original: "",
          inputValue: "",
          calculate: "",
        },
        {
          type: "groupprice",
          text: "商品基础批发价（团批）件（/件）",
          original: "",
          inputValue: "",
          calculate: "",
        },
      ],
      formData: {
        cmid: "",
        yue_price_base: "",
        yue_tuan_base: "",
        yue_price: "",
        yue_tuan: "",
        tai_price_base: "",
        tai_tuan_base: "",
        tai_price: "",
        tai_tuan: "",
        lu_price_base: "",
        lu_tuan_base: "",
        lu_price: "",
        lu_tuan: "",
        jia_price_base: "",
        jia_tuan_base: "",
        jia_price: "",
        jia_tuan: "",
      },
      multiPriceDetail: "",
      exchangeRates: [], // 汇率参数列表
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    this.getExrateList();
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.getShopMultiPrice();
        this.getDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 获取商品详情
    getDetail(id) {
      this.loading = false;
      let { priceCustom } = this;
      getCommidityDetail({ id }).then((res) => {
        this.detail = res;
        for (let i = 0; i < priceCustom.length; i++) {
          const type = priceCustom[i].type;
          let value = res[type];

          if (value === null || value === "") {
            value = 0;
          }
          priceCustom[i].original = value;
          priceCustom[i].calculate = value + 0; // 设置calculate属性为原始值加上0
        }
        this.loading = false;
      });
    },

    // 输入框的值发生变化
    updateCalculate(e, type) {
      this.debouncedChange(e, type);
    },

    // 防抖函数
    debouncedChange(newPrice, value) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        let { priceCustom } = this;
        const customObj = priceCustom.find((item) => item.type === value);
        customObj.inputValue = newPrice;
        customObj.calculate = calculator(customObj.original)
          .add(parseFloat(newPrice || 0))
          .toNumber();
      }, 800); // 设置延迟时间，单位为毫秒
    },

    // 处理汇率转换和更新formData的值
    handleConvert() {
      this.priceCustom.forEach((item) => {
        switch (item.type) {
          case "cbprice":
            // this.formData.yue_price_base = this.convertCurrency(
            //   item.calculate,
            //   "越南盾"
            // );
            // this.formData.tai_price_base = this.convertCurrency(
            //   item.calculate,
            //   "泰铢"
            // );
            // this.formData.lu_price_base = this.convertCurrency(
            //   item.calculate,
            //   "卢布"
            // );
            // this.formData.jia_price_base = this.convertCurrency(
            //   item.calculate,
            //   "加拿大元"
            // );
            break;
          case "pfprice":
            // this.formData.yue_tuan_base = this.convertCurrency(
            //   item.calculate,
            //   "越南盾"
            // );
            // this.formData.tai_tuan_base = this.convertCurrency(
            //   item.calculate,
            //   "泰铢"
            // );
            // this.formData.lu_tuan_base = this.convertCurrency(
            //   item.calculate,
            //   "卢布"
            // );
            // this.formData.jia_tuan_base = this.convertCurrency(
            //   item.calculate,
            //   "加拿大元"
            // );
            break;
          case "price":
            this.formData.yue_price = this.convertCurrency(
              item.calculate,
              "越南盾"
            );
            this.formData.tai_price = this.convertCurrency(
              item.calculate,
              "泰铢"
            );
            this.formData.lu_price = this.convertCurrency(
              item.calculate,
              "卢布"
            );
            this.formData.jia_price = this.convertCurrency(
              item.calculate,
              "加拿大元"
            );
            break;
          case "groupprice":
            this.formData.yue_tuan = this.convertCurrency(
              item.calculate,
              "越南盾"
            );
            this.formData.tai_tuan = this.convertCurrency(
              item.calculate,
              "泰铢"
            );
            this.formData.lu_tuan = this.convertCurrency(
              item.calculate,
              "卢布"
            );
            this.formData.jia_tuan = this.convertCurrency(
              item.calculate,
              "加拿大元"
            );
            break;
          default:
            break;
        }
      });
    },
    // 单独价格核算
    handleUnitPrice(name, type, text) {
      this.priceCustom.forEach((item) => {
        if (item.type == type) {
          this.formData[name] = this.convertCurrency(item.calculate, text);
        }
      });
    },

    // 计算汇率转换后的值
    convertCurrency(inputValue, currency) {
      const rateObj = this.exchangeRates.find(
        (item) => item.Currency === currency
      );
      if (
        currency == "韩元" ||
        currency == "越南盾" ||
        currency == "泰铢" ||
        currency == "日元" ||
        currency == "卢布"
      ) {
        return calculator(inputValue)
          .multiply(rateObj.rate)
          .toNumber()
          .toFixed();
      } else {
        let num = calculator(inputValue).multiply(rateObj.rate).toNumber();
        if (Number.isInteger(num)) {
          return num; // 如果是整数，直接返回
        } else {
          return num.toFixed(1); // 如果是小数，保留一位小数
        }
      }
      // return inputValue * rateObj.rate;
    },

    // 获取汇率参数列表
    getExrateList() {
      getExrateList().then((res) => {
        this.exchangeRates = res.list;
      });
    },

    getShopMultiPrice() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        this.multiPriceDetail = res;
        if (res.id) {
          // this.formData.yue_price_base = res.yue_price_base;
          // this.formData.yue_tuan_base = res.yue_tuan_base;
          this.formData.yue_price = res.yue_price;
          this.formData.yue_tuan = res.yue_tuan;
          // this.formData.tai_price_base = res.tai_price_base;
          // this.formData.tai_tuan_base = res.tai_tuan_base;
          this.formData.tai_price = res.tai_price;
          this.formData.tai_tuan = res.tai_tuan;
          // this.formData.lu_price_base = res.lu_price_base;
          // this.formData.lu_tuan_base = res.lu_tuan_base;
          this.formData.lu_price = res.lu_price;
          this.formData.lu_tuan = res.lu_tuan;
          // this.formData.jia_price_base = res.jia_price_base;
          // this.formData.jia_tuan_base = res.jia_tuan_base;
          this.formData.jia_price = res.jia_price;
          this.formData.jia_tuan = res.jia_tuan;
        }

        Toast.clear();
      });
    },
    // 多币种自动核算
    handleAccount() {
      accountShopMultiPrice({ cmid: this.formData.cmid }).then((res) => {
        // this.formData.yue_price_base = res.yue_price_base;
        // this.formData.yue_tuan_base = res.yue_tuan_base;
        this.formData.yue_price = res.yue_price;
        this.formData.yue_tuan = res.yue_tuan;
        // this.formData.tai_price_base = res.tai_price_base;
        // this.formData.tai_tuan_base = res.tai_tuan_base;
        this.formData.tai_price = res.tai_price;
        this.formData.tai_tuan = res.tai_tuan;
        // this.formData.lu_price_base = res.lu_price_base;
        // this.formData.lu_tuan_base = res.lu_tuan_base;
        this.formData.lu_price = res.lu_price;
        this.formData.lu_tuan = res.lu_tuan;
        // this.formData.jia_price_base = res.jia_price_base;
        // this.formData.jia_tuan_base = res.jia_tuan_base;
        this.formData.jia_price = res.jia_price;
        this.formData.jia_tuan = res.jia_tuan;
      });
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },

    handleReturn() {
      history.back();
    },
    // 价格输入失去焦点
    handleBlurPrice(name) {
      // let newPrice = this.formData[name].replace(/^(\d*(?:\.\d{0,2})?).*$/, "$1");
      // this.formData[name] = newPrice;
      this.formData[name] = this.formData[name].replace(/^(0+)|[^\d]+/g, ""); // 只保留数字
    },

    query() {
      let { formData, multiPriceDetail } = this;
      // if (formData.yue_price_base == "") {
      //   this.$toast("请输入越南盾零售底价");
      //   return;
      // }
      // if (formData.yue_tuan_base == "") {
      //   this.$toast("请输入越南盾团批底价");
      //   return;
      // }
      if (formData.yue_price == "") {
        this.$toast("请输入越南盾零售价");
        return;
      }
      if (formData.yue_tuan == "") {
        this.$toast("请输入越南盾团批价");
        return;
      }
      // if (formData.tai_price_base == "") {
      //   this.$toast("请输入铢零售底价");
      //   return;
      // }
      // if (formData.tai_tuan_base == "") {
      //   this.$toast("请输入泰铢团批底价");
      //   return;
      // }
      if (formData.tai_price == "") {
        this.$toast("请输入泰铢零售价");
        return;
      }
      if (formData.tai_tuan == "") {
        this.$toast("请输入泰铢团批价");
        return;
      }
      // if (formData.lu_price_base == "") {
      //   this.$toast("请输入卢布零售底价");
      //   return;
      // }
      // if (formData.lu_tuan_base == "") {
      //   this.$toast("请输入卢布团批底价");
      //   return;
      // }
      // if (formData.yue_price_base == "") {
      //   this.$toast("请输入");
      //   return;
      // }
      if (formData.lu_price == "") {
        this.$toast("请输入卢布零售价");
        return;
      }
      if (formData.lu_tuan == "") {
        this.$toast("请输入卢布团批价");
        return;
      }
      // if (formData.jia_price_base == "") {
      //   this.$toast("请输入加拿大元零售底价");
      //   return;
      // }
      // if (formData.jia_tuan_base == "") {
      //   this.$toast("请输入加拿大元团批底价");
      //   return;
      // }
      if (formData.jia_price == "") {
        this.$toast("请输入加拿大元零售价");
        return;
      }
      if (formData.jia_tuan == "") {
        this.$toast("请输入加拿大元团批价");
        return;
      }
      let params = formData;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (multiPriceDetail.id) {
        editShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopMultiPrice(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      .input_box {
        margin-bottom: 20px;
      }
      .rest_btn {
        background: #f62560;
        border: 1px solid rgba(173, 173, 173, 0.76);
        border-radius: 45px;
        font-size: 22px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        padding: 20px 30px;
        box-sizing: border-box;
        margin: 0 auto 60px;
        display: inline-block;
      }
      .limit_content {
        white-space: nowrap;
        .van_input {
          border: 1px solid #adadadc2;
          margin-left: 30px;
          border-radius: 45px;
          padding: 6px 10px;
        }
      }
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
    }
  }
  .account_btn {
    margin: 40px auto 100px;
  }
  .exrate {
    font-size: 20px;
    width: 600px;
    margin: 0 auto 30px;
    p {
      &:last-child {
        margin-top: 10px;
        line-height: 26px;
      }
    }
  }
  .price_custom_wrap {
    width: 600px;
    margin: 30px auto 0;
    .tit {
      font-size: 28px;
      margin-bottom: 20px;
    }
    .price_custom_content {
      font-size: 24px;
      .price_block {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0;
        }
        .original {
          // width: 290px;
        }
        .input_box {
          margin: 20px 0;
          // width: 200px;
          // margin-right: 20px;
        }
      }
    }
  }
}
</style>